import { useState } from "react";
import { resendResetPasswordEmail } from "src/services/AuthenticationAPIs";
import { message } from "antd";

export default function Resetpassword() {
  const [, setResendStatus] = useState("");

  const handleResend = async () => {
    try {
      const result = await resendResetPasswordEmail();

      if (result.status) {
        message.success("Email resent successfully!");
      } else {
        message.error(
          result.message || "Failed to resend email. Please try again."
        );
      }
    } catch {
      message.error("An error occurred. Please try again.");
    } finally {
      setResendStatus("");
    }
  };

  return (
    <>
      <div className="reset-pass-bg" style={{ backgroundImage: `url(/Icons/forget-password-bg.svg)` }} >
        <img src="/images/DpLogo.png" className="logo-design" alt="img" />
        <div className="app">
          <div className="signup-internal-container">
            <form className="formdesign">
              <img
                src="/images/envelopeopentext.png"
                className="user-lock"
                alt="envelopeopentext"
              />
              <h2 className="Reset-password">Follow The Link</h2>
              <p className="email-sent-detail ">
                A password reset link has been sent to your email address.
                Follow the link to reset your password .
              </p>

              <br />
              <br />
              <br />

              <p className="signup-page-text">
                Didn’t receive the email?&nbsp;
                <button
                  className="resend-button button"
                  onClick={handleResend}
                  type="button"
                >
                  Resend
                </button>
              </p>

              <div className="signup-page-text">
                Remember your password?&nbsp;
                <a href="/log-in">Sign In</a>
              </div>

              <br />
              <br />
              <br />
              <br />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
